import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-content" }
const _hoisted_2 = { class: "verify-code-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "sms-code-container" }

import { ref, reactive, onMounted, watch } from 'vue';
import { ElMessage } from 'element-plus';
import type { FormInstance, FormRules } from 'element-plus';
import { getCaptcha, sendSms, login } from '@/api/api';



export default /*@__PURE__*/_defineComponent({
  __name: 'LoginModal',
  props: {
    visible: { type: Boolean }
  },
  emits: ['update:visible', 'login-success'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const dialogVisible = ref(props.visible);
const loginFormRef = ref<FormInstance>();
const loginForm = reactive({
  mobile: '',
  verifyCode: '',
  smsCode: '',
});

const rules = reactive<FormRules>({
  mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }, { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }],
  verifyCode: [{ required: true, message: '请输入图形验证码', trigger: 'blur' }],
  smsCode: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }],
});

const captchaUrl = ref('');
const smsSent = ref(false);
const smsButtonText = ref('获取验证码');
let timer: any = null;

watch(() => props.visible, (val) => {
  dialogVisible.value = val;
  if (val) {
    refreshCaptcha();
  } else {
    // 弹窗关闭时清空表单
    resetForm();
  }
});

const handleClose = () => {
  emit('update:visible', false);
};

// 重置表单
const resetForm = () => {
  // 清空表单数据
  loginForm.mobile = '';
  loginForm.verifyCode = '';
  loginForm.smsCode = '';
  
  // 重置表单验证
  loginFormRef.value?.resetFields();
  
  // 清除倒计时
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
  smsSent.value = false;
  smsButtonText.value = '获取验证码';
  
  // 清空验证码图片
  captchaUrl.value = '';
};

const refreshCaptcha = async () => {
  try {
    const response = await getCaptcha();
    captchaUrl.value = URL.createObjectURL(response.data);
  } catch (error) {
    ElMessage.error('获取图形验证码失败');
  }
};

const sendSmsCode = async () => {
  if (!loginForm.mobile || !loginForm.verifyCode) {
    ElMessage.warning('请先输入手机号和图形验证码');
    return;
  }
  
  try {
    const response = await sendSms({ mobile: loginForm.mobile, verifyCode: loginForm.verifyCode });
    if (response.data && response.data.code === 0) {
      ElMessage.success('短信验证码已发送');
      smsSent.value = true;
      let count = 60;
      smsButtonText.value = `${count}s后重试`;
      timer = setInterval(() => {
        count--;
        if (count > 0) {
          smsButtonText.value = `${count}s后重试`;
        } else {
          clearInterval(timer);
          smsButtonText.value = '获取验证码';
          smsSent.value = false;
        }
      }, 1000);
    } else {
      ElMessage.error(response.data.msg || '发送短信验证码失败');
      refreshCaptcha();
    }
  } catch (error) {
    ElMessage.error('发送短信验证码失败');
    refreshCaptcha(); // Optionally refresh captcha on failure
  }
};

const handleLogin = () => {
  loginFormRef.value?.validate(async (valid) => {
    if (valid) {
      try {
        const response = await login({ mobile: loginForm.mobile, smsCode: loginForm.smsCode });
        // 判断code为0时才为成功
        if (response.data && response.data.code === 0) {
          // 保存登录接口返回的data参数到localStorage
          if (response.data.data) {
            localStorage.setItem('token', response.data.data);
          }
          ElMessage.success('登录成功');
          emit('login-success');
          handleClose();
        } else {
          // code不为0时，显示错误提示
          ElMessage.error(response.data?.msg || '登录失败');
        }
      } catch (error) {
        ElMessage.error('登录失败，请稍后重试');
      }
    }
  });
};

onMounted(() => {
  if (props.visible) {
    refreshCaptcha();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogVisible).value = $event)),
    title: "欢迎登录",
    width: "420px",
    onClose: handleClose,
    "close-on-click-modal": false,
    "custom-class": "login-dialog"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "dialog-subtitle" }, "如未注册系统会帮您自动进行注册", -1)),
        _createVNode(_component_el_form, {
          ref_key: "loginFormRef",
          ref: loginFormRef,
          model: loginForm,
          rules: rules,
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "手机号",
              prop: "mobile"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: loginForm.mobile,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginForm.mobile) = $event)),
                  placeholder: "请输入11位手机号",
                  size: "large"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "图形验证码",
              prop: "verifyCode"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_input, {
                    modelValue: loginForm.verifyCode,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginForm.verifyCode) = $event)),
                    placeholder: "请输入图形验证码",
                    size: "large"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("img", {
                    src: captchaUrl.value,
                    onClick: refreshCaptcha,
                    class: "captcha-img",
                    alt: "验证码"
                  }, null, 8, _hoisted_3)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "短信验证码",
              prop: "smsCode"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_input, {
                    modelValue: loginForm.smsCode,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((loginForm.smsCode) = $event)),
                    placeholder: "请输入短信验证码",
                    size: "large"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_el_button, {
                    onClick: sendSmsCode,
                    disabled: smsSent.value,
                    class: "sms-button",
                    text: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(smsButtonText.value), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: handleLogin,
                  class: "login-button",
                  size: "large"
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("登 录")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})